var map = {
	"./action.png": 818,
	"./approved.png": 819,
	"./done.png": 820,
	"./draft.png": 821,
	"./eng.svg": 822,
	"./filled.png": 823,
	"./french.svg": 824,
	"./german.svg": 825,
	"./inaction.png": 826,
	"./new.png": 827,
	"./pay.png": 828,
	"./rejected.png": 829,
	"./reviewed.png": 830,
	"./seen.png": 831,
	"./signed.png": 832,
	"./signed2.png": 833,
	"./ukraine.svg": 834
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 817;